module.exports = __webpack_public_path__ + "static/media/6.1.d0327770.png";